export { StoryInfoTrait } from './storyInfoTrait.js';
